import {isNil, mapObjIndexed, pluck} from "ramda";
import { DETECTED_FIELD_DATA_TYPE } from "../constants/project";

export const mergeDetectedFieldDefaultValue = (
  defaultValue,
  detectedFieldValue,
  attributes = [],
) => {
  const autoFieldKeys = pluck('name', attributes.filter((item) => item.type === "auto"));
  return mapObjIndexed((value, key) => {
    if (!isNil(detectedFieldValue[key])) {
      if (detectedFieldValue.type === DETECTED_FIELD_DATA_TYPE.checkbox && autoFieldKeys.includes(key)) {
        return value === "True";
      }
      if (detectedFieldValue.type === DETECTED_FIELD_DATA_TYPE.listBox && autoFieldKeys.includes(key)) {
        return value ? value.split("|") : [];
      }
      return detectedFieldValue[key];
    } else {
      if (detectedFieldValue.type === DETECTED_FIELD_DATA_TYPE.listBox && autoFieldKeys.includes(key)) {
        return [];
      }
    }
    return value;
  }, detectedFieldValue);
};

export const getDetectedFieldInitData = (data,   attributes = []) => {
  const autoFieldKeys = pluck('name', attributes.filter((item) => item.type === "auto"));
  return mapObjIndexed((value, key) => {
    if (autoFieldKeys.includes(key) && data.type === DETECTED_FIELD_DATA_TYPE.checkbox) {
      return value === "True";
    }

    if (autoFieldKeys.includes(key) && data.type === DETECTED_FIELD_DATA_TYPE.listBox) {
      return value ? value.split("|") : [];
    }
    return value;
  }, data);
};
